<template>
    <article id="phonemitt_main" class="phonemitt-stage">
        <section class="phonemitt_control">
            <button class="btn button" @click="activateCamera">Camera</button>
            <button class="btn button" @click="activateParallax">Parallax</button>
        </section>

        <section class="phonemitt_gameChoice" v-if="choice === true">
            <section class="phonemitt_experience">
                <p class="Eyebrow8bit">WELCOME TO THE</p>
                <div class="TitleWrapper8bit">
                    <img class="LandingHead8bit" src="/getattachment/c567eed6-a454-432f-87cd-6a0a2ae346ff/CashCatch-Landing-Header.png"/>
                </div>
                <p class="Body8bit">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euism od tincidunt ut laoreet dolore adipiscing elit, sed diam nima gna aliquam erat olutpat.</p>
                <p class="Disclaimer8bit">For best game experience, please allow access to your phone's motion sensors and camera.</p>
                <p class="pMargin8Bit" style="position:relative; z-index: 10;">
                    <input type="checkbox" id="acceptTerms" v-model="isChecked" />
                    <label class="Body8bit" for="acceptTerms"> I verify that I am 18 years of age or older.</label>
                </p>
                <p class="pMargin8Bit verifyError8Bit" v-if="showError" style="position:relative; z-index: 10;"> Please verify you are 18 years of age or older.</p>
            </section>
        </section>

        <div class="phonemitt_game" v-if="gameplay === true">
            <img src="/getattachment/a58c8126-e43b-4944-b077-5a2def9a2ae2/Baseball-Glove-Temp.png" class="Glove8bit" />

            <section class="phonemitt phonemitt_camera" v-if="camera === true">
                <!-- UAT -->
                <img src="/getattachment/6ece7d86-2a40-4d00-a1d5-255a9002b881/CashCatch_flyby1.gif" alt="" class="phonemitt_overlay_image" v-if="flyby1 === true">
                <img src="/getattachment/08832c1b-321e-4984-b03e-669533d4a15e/CashCatch_flyby2.gif" alt="" class="phonemitt_overlay_image" v-if="flyby2 === true">
                <img src="/getattachment/6dbb6956-9cd4-45e3-a06e-2fc61ca2c6a4/CashCatch_end1.gif" alt="" class="phonemitt_overlay_image" v-if="end1 === true">
                <img src="/getattachment/9dd6801a-ed65-408e-aba5-276bd5952b2f/CashCatch_end2.gif" alt="" class="phonemitt_overlay_image" v-if="end2 === true">
                <img src="/getattachment/a62a848d-19d1-495c-ba56-3d79eb2ba936/CashCatch_endWin.gif" alt="" class="phonemitt_overlay_image" v-if="endWin === true">

                <!-- dev -->
                <!-- <img src="/getattachment/aa7f3489-b6d0-4a2d-b858-75db020b8444/CashCatch_flyby1.gif" alt="" class="phonemitt_overlay_image" v-if="flyby1 === true">
                <img src="/getattachment/4808f844-4433-460e-a4d1-18315be86623/CashCatch_flyby2.gif" alt="" class="phonemitt_overlay_image" v-if="flyby2 === true">
                <img src="/getattachment/f8a64a35-f8ba-41f9-b6da-19edb6abb1aa/CashCatch_end1.gif" alt="" class="phonemitt_overlay_image" v-if="end1 === true">
                <img src="/getattachment/9b20d9b2-70cd-4570-b8b1-5fe78af8a201/CashCatch_end2.gif" alt="" class="phonemitt_overlay_image" v-if="end2 === true">
                <img src="/getattachment/5bddbde9-ed2c-4475-a2e6-cd934d7b6cc8/CashCatch_endWin.gif" alt="" class="phonemitt_overlay_image" v-if="endwin === true"> -->

                <video id="background-video" autoplay muted loop></video>
            </section>

            <section class="phonemitt phonemitt_parallax" v-if="parallax === true">
                <div id="mouseTracking"></div>
                <!-- UAT -->
                <img src="/getattachment/6ece7d86-2a40-4d00-a1d5-255a9002b881/CashCatch_flyby1.gif" alt="" class="phonemitt_overlay_image" v-if="flyby1 === true">
                <img src="/getattachment/08832c1b-321e-4984-b03e-669533d4a15e/CashCatch_flyby2.gif" alt="" class="phonemitt_overlay_image" v-if="flyby2 === true">
                <img src="/getattachment/6dbb6956-9cd4-45e3-a06e-2fc61ca2c6a4/CashCatch_end1.gif" alt="" class="phonemitt_overlay_image" v-if="end1 === true">
                <img src="/getattachment/9dd6801a-ed65-408e-aba5-276bd5952b2f/CashCatch_end2.gif" alt="" class="phonemitt_overlay_image" v-if="end2 === true">
                <img src="/getattachment/a62a848d-19d1-495c-ba56-3d79eb2ba936/CashCatch_endWin.gif" alt="" class="phonemitt_overlay_image" v-if="endWin === true">

                <!-- dev -->
                <!-- <img src="/getattachment/aa7f3489-b6d0-4a2d-b858-75db020b8444/CashCatch_flyby1.gif" alt="" class="phonemitt_overlay_image" v-if="flyby1 === true">
                <img src="/getattachment/4808f844-4433-460e-a4d1-18315be86623/CashCatch_flyby2.gif" alt="" class="phonemitt_overlay_image" v-if="flyby2 === true">
                <img src="/getattachment/f8a64a35-f8ba-41f9-b6da-19edb6abb1aa/CashCatch_end1.gif" alt="" class="phonemitt_overlay_image" v-if="end1 === true">
                <img src="/getattachment/9b20d9b2-70cd-4570-b8b1-5fe78af8a201/CashCatch_end2.gif" alt="" class="phonemitt_overlay_image" v-if="end2 === true">
                <img src="/getattachment/5bddbde9-ed2c-4475-a2e6-cd934d7b6cc8/CashCatch_endWin.gif" alt="" class="phonemitt_overlay_image" v-if="endwin === true"> -->

                <div class="horizontal-scroll-wrapper">
                    <div class="img-wrapper slower" id="topImage" ref="topImage">
                        <a href="/getattachment/7b4be047-18fb-4693-90bd-532ef9f753d4/top.png" target="_blank" rel="noopener">
                            <img src="/getattachment/7b4be047-18fb-4693-90bd-532ef9f753d4/top.png" alt="">
                        </a>
                    </div>
                    <div class="img-wrapper faster" id="middleImage" ref="midImage">
                        <a href="/getattachment/e4774dc0-9443-44cb-95eb-54c4b497768b/mid.png" target="_blank" rel="noopener">
                            <img src="/getattachment/e4774dc0-9443-44cb-95eb-54c4b497768b/mid.png" alt="">
                        </a>
                    </div>
                    <div class="img-wrapper faster1" id="bottomImage" ref="bottomImage">
                        <a href="/getattachment/47caad4c-b20a-4028-878b-459963d3a491/bottom.png" target="_blank" rel="noopener">
                            <img src="/getattachment/47caad4c-b20a-4028-878b-459963d3a491/bottom.png" alt="">
                        </a>
                    </div>
                </div>
            </section>
        </div>

        <div class="end" v-if="gameOver === true">
            <p v-if="win === true">WINNER!!!!</p>
            <p v-else>Drawing Entry!</p>
        </div>
    </article>
</template>

<script>
    // import $ from 'jquery';

    export default {
        components: {
           
        },
        data: function () {
            return {
                events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
                token: '',
                logged: false,
                login: false,
                userAuthed: '',
                notEnabledNotLogged: false,
                notEnabledLogged: false,
                alreadyPlayed: false,
                enabledNotLogged: false,
                enabledLogged: false,
                gameTop: false,
                intermision: false,
                gameBottom: false,
                error: false,
                area: '',
                city: '',
                team: '',
                apiTeam: 0,
                choices: ['SINGLE', 'DOUBLE', 'HOME RUN'],
                topchoices: ['SCREWBALL', 'FASTBALL', 'KNUCKLEBALL'],
                topChoice: '',
                single: false,
                double: false,
                hr: false,
                screwball: false,
                fastball: false,
                knuckleball: false,
                bottomChoice: '',
                animationTop: false,
                prizeWonTop: false,
                prizeWonBottom: false,
                drawEntryTop: false,
                drawEntryBottom: false,
                animationIntro: false,
                animationTop: false,
                animationBottom: false,
                cle: false,
                reds: false,
                win: false,
                lose: false,
                currentState: "-1",
                choice: 0,
                testing: false, 
                masterControl: false,
                gameplay: false,
                camera: false,
                parallax: false,
                GameOverWinner: false,
                choice: true,
                playball: false,
                flyby1: false,
                flyby2: false,
                end1: false,
                end2: false,
                endWin: false,
                gameOver: false,
                previousX: 0,
                previousY: 0,
                topImageLeft: -220,
                middleImageLeft: -220,
                bottomImageLeft: -220
            }
        },
        mounted: function () {
            // this.getToken();

            this.getWinner();
            
        },
        methods: {
            trackEvents(event) {
                if (this.parallax === true) {
                    this.events.forEach( function (event){
                        window.addEventListener(event, this.log)
                    }, this)
                }
            },
            log(event) {
                let topImageElement = document.getElementById('topImage'),
                    middleImageElement = document.getElementById('middleImage'),
                    bottomImageElement = document.getElementById('bottomImage');

                let topImageLeft = this.topImageLeft,
                    middleImageLeft = this.middleImageLeft,
                    bottomImageLeft = this.bottomImageLeft;

                let clientX = event.clientX,
                    clientY = event.clientY;

                if (clientX > this.previousX) {
                    this.topImageLeft < -200 ? topImageLeft = topImageLeft + 1 : topImageLeft = this.topImageLeft;
                    topImageElement.style.left = topImageLeft.toString() + 'px';

                    this.middleImageLeft < -180 ? middleImageLeft = middleImageLeft + 2 : middleImageLeft = this.middleImageLeft;
                    middleImageElement.style.left = middleImageLeft.toString() + 'px';

                    this.bottomImageLeft < -120 ? bottomImageLeft = bottomImageLeft + 4 : bottomImageLeft = this.bottomImageLeft;
                    bottomImageElement.style.left = bottomImageLeft.toString() + 'px';
                } else {
                    this.topImageLeft > -240 ? topImageLeft = topImageLeft - 1 : topImageLeft = this.topImageLeft;
                    topImageElement.style.left = topImageLeft.toString() + 'px';

                    this.middleImageLeft > -260 ? middleImageLeft = middleImageLeft - 2 : middleImageLeft = this.middleImageLeft;
                    middleImageElement.style.left = middleImageLeft.toString() + 'px';

                    this.bottomImageLeft > -300 ? bottomImageLeft = bottomImageLeft - 4 : bottomImageLeft = this.bottomImageLeft;
                    bottomImageElement.style.left = bottomImageLeft.toString() + 'px';
                }

                // if (clientY > this.previousY) {
                //     console.log("Up");
                // } else {
                //     console.log("Down")
                // }

                this.previousX = clientX;
                this.topImageLeft = topImageLeft;
                this.middleImageLeft = middleImageLeft;
                this.bottomImageLeft = bottomImageLeft;
                this.previousY = clientY;
            },
            getWinner() {
                if (this.chance() > 50) {
                    this.win = true;
                }
            },
            chance() {
                let random = Math.floor(Math.random() * (100 - 1 + 1) + 1);
                return random;
            },
            activateParallax() {
                let _this = this;
                this.parallax = true;
                this.camera = false;
                this.choice = false;
                this.gameplay = true;

                this.trackEvents();

                this.startGame();
            },
            startGame() {
                let _this = this;

                setTimeout(() => {
                    if (_this.chance() > 50) {
                        _this.flyby1 = true;
                    } else {
                        _this.flyby2 = true;
                    }
                }, 1000);

                if (this.win === false) {
                    setTimeout(() => {
                        if (_this.chance() > 50) {
                            _this.end1 = true;
                        } else {
                            _this.end2 = true;
                        }
                    }, 4000);
                } else {
                    setTimeout(() => {
                        this.endWin = true;
                    }, 4000);
                }

                setTimeout(() => {
                    this.gameOver = true;
                    this.parallax = false;
                    this.camera = false;
                    this.choice = false;
                    this.gameplay = false;
                }, 6000);
            },
            activateCamera() {
                let _this = this;
                this.parallax = false;
                this.camera = true;
                this.choice = false;
                this.gameplay = true;

                const video = document.getElementById('background-video');

                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({ video: {facingMode: 'environment'} })
                    .then(stream => {
                        video.playsInline = true;
                        video.srcObject = stream;

                        _this.startGame();
                    })
                    .catch(error => {
                        console.error('Error accessing camera:', error);
                    });
                } else {
                    console.error('getUserMedia is not supported on this browser');
                }
            },
            // getToken() {
            //     this.getAPItoken()
            //     .then((token) => {
            //         this.token = token;
            //         this.user = this.$cookies.get('apiToken');
            //         this.userAuthed = this.isUserAuthed();
                    
            //         this.getTeam();
            //         this.testGame(); // TESTING ONLY
            //         // this.getState(); // NOT TESTING ONLY
            //         this.appendStyles();
            //     });
            // },
            // loadComponent() {
            //     $(document).ready(function () {
            //         $('.close-button').on('click', function () {
            //             $("#globalLogInModal").hide();
            //             $("#globalLoginBlocker").hide();
            //         })

            //         $(".btn_popupLogIn").on('click', function () {
            //             $("#globalLogInModal").show();
            //             $("#globalLoginBlocker").show();
            //         });
            //     })
            // },
            // toggleTesting() {
            //     this.testing = !this.testing;
            // },
            // testWin() {
            //     this.testing = true;
            //     this.winner = true;
            //     this.loser = false;
            // },
            // testLose() {
            //     this.testing = true;
            //     this.winner = false;
            //     this.loser = true;
            // },
            // appendStyles() {
            //     let head = document.getElementsByTagName("head"),
            //         topMenu = document.getElementById("top-menu"),
            //         footer = document.getElementsByTagName("footer"),
            //         footerMenu = document.getElementsByClassName("footer-menu"),
            //         sheet = document.createElement("link"),
            //         container = document.getElementById("container"),
            //         main = document.getElementById("main");

            //     main.style.top = "-22px";

            //     sheet.type = "text/css";
            //     sheet.rel = "stylesheet";
            //     sheet.href = "https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap";

            //     setTimeout(() => {
            //         footer[0].style.background = "transparent";
            //         footer[0].style.marginTop = "0px";
            //         footer[0].style.height = "1px";
            //         footer[0].style.overflow = "hidden";

            //         topMenu.style.display = "none !important";
            //         topMenu.remove();
            //         footerMenu[0].style.display = "none !important";

            //         container.style.overflow = "initial";
            //         container.style.position = "relative";
            //         container.style.top = "-22px";

            //         head[0].appendChild(sheet);
            //     }, 500)
                
            // },
            // testGame() {
            //     // console.log("Testing Game");
            //     let url = process.env.VUE_APP_APIURL + '/1.0/Games/EightBitAtBat/ToggleGameInstance',
            //         apiToken = this.token;

            //     fetch(url, {
            //         method: 'GET',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Authorization': "Bearer " + apiToken
            //         }
            //     })
            //     .then((response) => response.json())
            //     .then((json) => {
            //         // console.log('=== TESTING ===');
            //         // console.log(json);
            //     })
            //     .then(() => {
            //         this.getState();
            //     })
            // },
            // getTeam() {
            //     // console.log('getting team')
            //     let pathName = window.location.pathname;

            //     if (pathName.indexOf('reds') >= 0) {
            //         this.cle = false;
            //         this.reds = true;
            //         this.area = 'EnterEightBitAtBatCincinnati';
            //         this.team = 'Reds';
            //         this.city = 'Cincinnati';
            //         this.apiTeam = 1;
            //     } else {
            //         this.cle = true;
            //         this.reds = false;
            //         this.area = 'EnterEightBitAtBatCleveland';
            //         this.team = 'Guardians';
            //         this.city = 'Cleveland';
            //         this.apiTeam = 0; 
            //     }

            //     // console.log(pathName.indexOf('reds'));

            //     // this.setImages():
            // },
            // setImages() {
            //     let test = document.getElementById('testImage');

            //     test.style.backgroundImage = 'url("../media/site-design/8bit/2021/General/error.png")';
            //     // let clouds = document.getElementsByClassName('bkgnd-cloud'),
            //     //     ballToss = document.getElementById('image-balltoss'),
            //     //     sbh = 

            //     // if (this.cle === true && this.reds === false) {
            //     //     // Set all images from Guardians using this.cleImages
            //     // } else {
            //     //     // Set all images for reds using this.redImages
            //     // }
            // },
            // setState(panel) {
            //     this.currentState = panel;
            // },
            // getState(panel) {
            //     if (panel === null || panel === undefined) {
            //         // console.log(panel)
            //         let url = process.env.VUE_APP_APIURL + '/1.0/Games/EightBitAtBat/LoadGame?team=' + this.apiTeam + '&userId=' + this.user.user.userId,
            //             apiToken = this.token;

            //         fetch(url, {
            //             method: 'POST',
            //             headers: {
            //                 'Content-Type': 'application/json',
            //                 'Authorization': "Bearer " + apiToken
            //             }
            //         })
            //         .then((response) => response.json())
            //         .then((json) => {
            //             this.currentState = json.data;
            //             if (this.currentState === 4) {
            //                 this.gameTop = true;
            //                 this.gameBottom = false;
            //                 // console.log('Game Top ' + this.gameTop);
            //             } else if (this.currentState === 8) {
            //                 this.gameTop = false;
            //                 this.gameBottom = true;
            //                 // console.log('Game Bottom ' + this.gameBottom);
            //             } else {
            //                 this.gameTop = false;
            //                 this.gameBottom = false;
            //                 // console.log('No Game')
            //             }
            //             // console.log('8Bit Testing Stoppoint')
            //             // console.log(json);
            //             // console.log(this.currentState);
            //         })
            //     } else {
            //         this.testing = true;
            //         this.currentState = panel;
            //         if (this.currentState === 4) {
            //             this.gameTop = true;
            //             this.gameBottom = false;
            //             // console.log('Game Top ' + this.gameTop);
            //         } else if (this.currentState === 8) {
            //             this.gameTop = false;
            //             this.gameBottom = true;
            //             // console.log('Game Bottom ' + this.gameBottom);
            //         } else {
            //             this.gameTop = false;
            //             this.gameBottom = false;
            //             // console.log('No Game')
            //         }
            //         // console.log('=== 8Bit Testing ===')
            //         // console.log(this.currentState);
            //     }

            //     if (this.enabledNotLoggedIn) {
            //         setTimeout(function() {
            //             background.classList.remove('bitbat-black');
            //             background.classList.add('bitbat-sky');
            //         }, 2250);
            //     }

            //     let _this = this;

            //     _this.animationIntro = true;

            //     setTimeout(() => {
            //         _this.animationIntro = false;
            //         if (_this.currentState === 0 || _this.currentState === 1 || _this.currentState === 2) {
            //             _this.login = true;
            //             this.loadComponent();
            //         }
            //     }, 2250);
            // },
            // getWinner(id) {
            //     /** GET WINNER RETURN */
            //     // console.log(this.testing)
            //     if (this.testing === false) {
            //         let userId = this.user.user.userId,
            //             url = process.env.VUE_APP_APIURL + '/1.0/Games/EightBitAtBat/EnterEightBitAtBat?userId=' + userId + '&team=' + this.apiTeam,
            //             playerChoice = id;

            //         fetch(url, {
            //             method: 'POST',
            //             headers: {
            //                 'Content-Type': 'application/json',
            //                 'Authorization': "Bearer " + this.token
            //             }
            //         })
            //         .then((response) => response.json())
            //         .then((json) => {
            //             // console.log('=== Get Winner ===')
            //             this.gameTop ? this.playResultTop(json, id) : this.playResultBottom(json, id);
            //             return json;
            //         })
            //     } else {
            //         this.gameTop ? this.playResultTop({"data": this.winner}, id) : this.playResultBottom({"data": this.winner}, id);
            //         return this.winner;
            //     }
            // }, 
            // setScrewball() {
            //     let outcome = this.getWinner('SCREWBALL');

            //     // outcome ? this.screwball = true : this.fastball = true;
            //     this.screwball = true;
            //     this.fastball = false;
            //     this.knuckleball = false;
            // },
            // setFastball() {
            //     let outcome = this.getWinner('FASTBALL');

            //     // outcome ? this.fastball = true : this.knuckleball = true;
            //     this.screwball = false;
            //     this.fastball = true;
            //     this.knuckleball = false;
            // },
            // setKnuckleball() {
            //     let outcome = this.getWinner('KNUCKLEBALL');

            //     // outcome ? this.knuckleball = true : this.screwball = true;
            //     this.screwball = false;
            //     this.fastball = false;
            //     this.knuckleball = true;
            // },
            // playResultTop(json, id) {
            //     let _this = this;
            //     // Winner comes from API, Choice comes from button in game top section
            //     // console.log('=== Play Result Top ===');
            //     // console.log(json);
            //     // console.log(id);

            //     let winner = json.data,
            //         choice = id;

            //     let animationTiming = 6800;

            //     if (winner === true) {
            //         this.winner = true;
            //         this.loser = false;

            //         // console.log('Winner!')
            //         // console.log(typeof(winner))

            //         animationTiming = 11800;
            //     } else {
            //         this.winner = false;
            //         this.loser = true;

            //         // console.log('Loser!')
            //         // console.log(typeof(winner))
            //     }

            //     this.topChoice = id;

            //     // Add method for every button "Screwball", "Fastball", "Knuckleball" etc to change their state from true/false

            //     this.gameTop = false;
            //     // console.log('game top ' + this.gameTop)
            //     this.animationTop = true;
            //     // console.log('Animation Top ' + this.animationTop)

            //     // console.log(animationTiming)

            //     setTimeout(function() {
            //         _this.animationTop = false;
            //         _this.winner ? _this.prizeWonTop = true : _this.drawEntryTop = true;
            //     }, animationTiming);

            //     return false;
            // },
            // playResultBottom(json, id) {
            //     let _this = this;
            //     // console.log('=== Play Result Bottom ===');
            //     // console.log(json);
            //     // console.log(id);

            //     let winner = json.data,
            //         choice = id,
            //         animation = id;

            //     let animationTiming = 0;

            //     if (id === 'SINGLE' && winner === true) {
            //         animationTiming = 5200;
            //     } else {
            //         animationTiming = 8000;
            //     }

            //     if (winner === true) {
            //         this.winner = true;
            //         this.loser = false;

            //         if (choice === 'SINGLE') {
            //             this.choice = 1;
            //         } else if (choice === 'DOUBLE') {
            //             this.choice = 0;
            //         } else {
            //             this.choice = 2;
            //         }
            //     } else {
            //         this.winner = false;
            //         this.loser = true;

            //         // Set animation here for non-winner
            //         if (choice === 'SINGLE') {
            //             this.choice = Math.random() < 0.5 ? 0 : 2;
            //         } else if (choice === 'DOUBLE') {
            //             this.choice = Math.random() < 0.5 ? 1 : 2;
            //         } else {
            //             this.choice = Math.random() < 0.5 ? 0 : 1;
            //         }
            //     }

            //     this.bottomChoice = id;

            //     this.gameBottom = false;
            //     this.animationBottom = true;

            //     setTimeout(function() {
            //         _this.animationBottom = false;
            //         // console.log(animationTiming)
            //         _this.winner ? _this.prizeWonBottom = true : _this.drawEntryBottom = true;
            //     }, animationTiming);

            //     return false;
            // }
		}
    };
</script>

<style lang="scss" scoped>
    .contentRow {
        padding-left: 0;
        padding-right: 0;
    }
    #phonemitt_main {
        padding-top: 10px;
        background: linear-gradient(to bottom,
            rgb(15, 65, 36) 10%, 
            rgb(27, 95, 56) 30%, 
            rgb(36, 114, 74) 50%, 
            rgb(28, 96, 59) 70%, 
            rgb(14, 63, 34) 90%
        );
        height: 1024px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .phonemitt_control {
            display: flex;
            position: relative;
            justify-content: flex-start;

            .button {
                z-index: 101;
            }
        }

        .phonemitt_gameChoice {
            .phonemitt_experience {
                .TitleWrapper8bit{
                    display: flex;
                }
                .HeadTextWrapper8bit{
                    text-align: center;
                    position: relative;
                    left: 2%;
                }

                .LandingHead8bit{
                    width: 100%;
                    margin-bottom: 15px;
                }

                .pMargin8Bit{
                    margin-bottom:3px;
                    input{
                    margin:0px;
                    }
                }
                .verifyError8Bit{
                    color: rgb(245, 43, 43);
                    font-size: 1.5rem;
                    line-height: 2rem;
                    max-width:325px;
                    font-weight: 400;
                }

                .Dots8bit {
                    position: absolute;
                    width: 100vw;
                    height: 25vh;
                    bottom: 0;
                    overflow: hidden;
                    z-index: 0;
                }
            }
        }

        .phonemitt_game {
            position: relative;
            width: 600px;
            max-width: 600px;
            height: 91vh;

            .Glove8bit {
                position: absolute;
                bottom:15%;
                left: 50%;
                transform: translateX(-50%);
                width: 200px !important;
                height: 200px !important;
                z-index: 4;
            }

            .phonemitt_camera {
                overflow: hidden;
                z-index: 100;
            }

            .phonemitt_overlay_image {
                position: absolute;
                height: 91vh;
                z-index: 3;
                pointer-events: none;
            }

            .phonemitt_parallax {
                height: 810px;
                width: 600px;
                max-width: 600px;
                margin: 0 auto;
                overflow-x: hidden;
                overflow-y: hidden;

                .horizontal-scroll-wrapper {
                    // display: flex;
                    // flex-direction: column;
                    // align-items: center;
                    // width: 100vh;
                    // transform: rotate(-90deg) translate3d(0, -100vh, 0); /* creates the horizontal scrolling effect */
                    // transform-origin: right top;
                    // overflow-y: auto;
                    // overflow-x: hidden;
                    // padding: 0;
                    // height: 100vw;
                    // perspective: 1px;
                    // transform-style: preserve-3d;
                    // padding-bottom: 10rem;

                    .img-wrapper {
                        // transform: rotate(90deg);
                        // display: flex;
                        // align-items: center;
                        // justify-content: center;
                        // min-height: 40vh;
                        // transform-origin: 50% 50%;
                        // transform: rotate(90deg) translateZ(.1px) scale(0.9) translateX(0px) translateY(-3vh);
                        // transition: 1s;
                    }

                    .img-wrapper:hover {
                        // min-height: 65vh;
                    }

                    .slower {
                        // transform: rotate(90deg) translateZ(-.2px) scale(1.1) translateX(0%) translateY(-35vh);
                        // transform: scale(1.8);
                        width: 180%;
                        position: absolute;
                        top: 0;
                        left: -220;
                        // transition: 0.2s;
                    }

                    .faster {
                        // transform: rotate(90deg) translateZ(.15px) scale(1) translateX(-20%) translateY(-5vh);
                        position: absolute;
                        width: 180%;
                        // transform: scale(1.8);
                        bottom: 20%;
                        left: -220;
                        // transition: 0.2s;
                    }

                    .faster1 {
                        // transform: rotate(90deg) translateZ(.05px) scale(1.8) translateX(-30%) translateY(10vh);
                        // transform: scale(1.8);
                        width: 180%;
                        position: absolute;
                        bottom: 0;
                        left: -220px;
                        // transition: 0.2s;
                    }
                }
            }
        }
    }

    .phonemitt {
        margin: 0 auto;
        width: 100%;
        max-width: 768px;
        max-height: 1024px;
    }
    
    #background-video {
        position: relative;
        top: 0;
        left: 0;
        min-width: 100%;
        min-height: 810px;
        z-index: 1;
        object-fit: cover; /* Prevents video from distorting */
        max-width: 768px;
        max-height: 1024px;
    }

    .end p {
        color: white;
        font-size: 3em;
        font-weight: bold;
    }

    #mouseTracking {
        display: block;
        position: relative;
        width: 300px;
        height: 300px;
    }
</style>